/*
 * ACS artwork notice
 * ---------------------------------------------------------------------------
 * States, beside Globo's uploader, whether a file is actually attached.
 *
 * WHY THIS IS A WARNING AND NOT A BLOCK: a no-artwork order is a supported
 * path here, not purely a mistake — the product copy says "A design fee will
 * apply if you don't have an existing design", and there is a Hire A Designer
 * product. Refusing the order would turn away the customers that path exists
 * for. So this makes the state visible and says what happens next, and leaves
 * the decision with the shopper.
 *
 * Globo owns the uploader markup and re-renders it on its own schedule, so
 * nothing here edits Globo's DOM: the notice is our own element, appended after
 * its field, and a MutationObserver re-attaches it if Globo redraws.
 */
(function () {
  var FIELD = 'Artwork';
  var noticeId = 'acs-artwork-notice';

  function fileInput() {
    return document.querySelector('.gpo-app input[type="file"][data-field-name="' + FIELD + '"]');
  }

  /** The Globo field wrapper we sit under, falling back to the input's parent. */
  function anchorFor(input) {
    return (
      input.closest('.gpo-element, .gpo-field, [class*="gpo-element"]') ||
      input.parentElement
    );
  }

  function build() {
    var el = document.createElement('p');
    el.id = noticeId;
    el.className = 'acs-artwork-notice';
    // Announced when it changes, because the shopper's own action changes it.
    el.setAttribute('role', 'status');
    return el;
  }

  function attachedFiles(input) {
    if (input.files && input.files.length) return input.files.length;
    // Globo moves the file out of the input once uploaded and shows its own
    // chip, so an empty FileList is not proof that nothing was attached.
    var app = document.querySelector('.gpo-app');
    if (!app) return 0;
    var chips = app.querySelectorAll(
      '[class*="gpo-file-item"], [class*="file-name"], [class*="gpo-uploaded"]'
    );
    return chips.length;
  }

  function render() {
    var input = fileInput();
    if (!input) return;

    var anchor = anchorFor(input);
    var el = document.getElementById(noticeId);
    if (!el) el = build();
    // Re-append rather than assume it survived a Globo redraw.
    if (el.parentElement !== anchor) anchor.appendChild(el);

    var count = attachedFiles(input);
    if (count > 0) {
      el.dataset.state = 'ok';
      el.textContent =
        count === 1 ? 'Artwork attached.' : count + ' files attached.';
    } else {
      el.dataset.state = 'warn';
      el.textContent =
        "No artwork attached yet — you can still order, and we'll email you to collect it. A design fee applies if you'd like us to create the artwork.";
    }
  }

  function start() {
    if (!document.querySelector('.gpo-app')) return;
    render();

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="file"]')) {
        // Globo processes the file asynchronously; let it settle first.
        window.setTimeout(render, 250);
      }
    });

    var app = document.querySelector('.gpo-app');
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        render();
      });
    });
    observer.observe(app, { childList: true, subtree: true });
  }

  /* Globo mounts after the theme, so wait for its app to exist rather than for
     DOMContentLoaded, which fires well before it. Bounded so a product without
     Globo never leaves an interval running. */
  function waitForGlobo() {
    if (document.querySelector('.gpo-app input[type="file"]')) return start();
    var tries = 0;
    var t = window.setInterval(function () {
      tries += 1;
      if (document.querySelector('.gpo-app input[type="file"]')) {
        window.clearInterval(t);
        start();
      } else if (tries > 40) {
        window.clearInterval(t);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForGlobo);
  } else {
    waitForGlobo();
  }
})();
